exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*---------------------------------------------------------------------------------------------\r\n *  Copyright (c) Microsoft Corporation. All rights reserved.\r\n *  Licensed under the MIT License. See License.txt in the project root for license information.\r\n *--------------------------------------------------------------------------------------------*/\r\n\r\n.context-view .monaco-menu {\r\n\tmin-width: 130px;\r\n}\r\n\r\n.context-view-block {\r\n\tposition: fixed;\r\n\tleft:0;\r\n\ttop:0;\r\n\tz-index: -1;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n}", ""]);

// exports
